import React, { InputHTMLAttributes } from "react";
import classNames from "classnames";

import styles from "./Submit.module.css";

const Submit = (props: InputHTMLAttributes<HTMLInputElement>) => (
  <div className={classNames(styles.inputWrapper, styles.submitWrapper)}>
    <input type="submit" {...props} className={classNames(styles.submit, props.className)} />
    <span className={styles.glow}></span>
  </div>
);

export default Submit;
